import { SimpleEntityGridActionCellButton } from "src/app/components/grid/CellRenderer/SimpleEntityGridActionCell/SimpleEntityGridActionCell";
import { UserRole } from "src/app/transports/user";
import { UserModel } from "src/app/types/UserModel";

export default function useWaitingGridActions(currentUser: UserModel) {
    const actions: SimpleEntityGridActionCellButton[] = [];

    if (currentUser.role == UserRole.ROLE_ADMIN) {
        actions.push("edit");
    }
    if (
        currentUser.role == UserRole.ROLE_ADMIN ||
        currentUser.role == UserRole.ROLE_LEAD_LINKER ||
        currentUser.role == UserRole.ROLE_LINKER
    ) {
        actions.push("sendText");
        actions.push("viewText");
    }
    if (
        currentUser.role == UserRole.ROLE_ADMIN ||
        currentUser.role == UserRole.ROLE_PROJECT_MANAGER ||
        currentUser.role == UserRole.ROLE_LEAD_PROJECT_MANAGER ||
        currentUser.role == UserRole.ROLE_LEAD_LINKER ||
        currentUser.role == UserRole.ROLE_LINKER
    ) {
        actions.push("disable");
        actions.push("addUrl");
    }
    if (
        currentUser.role == UserRole.ROLE_ADMIN ||
        currentUser.role == UserRole.ROLE_LEAD_LINKER ||
        currentUser.role == UserRole.ROLE_LINKER
    ) {
        actions.push("removeRD");
    }
    return actions;
}
